import { SpriteAssetSpec } from "@westpierstudio/luma/factory/PixiFactory";
import { View } from "@westpierstudio/luma/mvc";
import { GameServices } from "game/GameServices";
import { Container } from "pixi.js";

export class Background extends View {
    private baseContainer: Container;
    private vsContainer: Container;

    constructor(protected override readonly services: GameServices) {
        super(services);

        const {factory, layout, resources} = this.services;
        const spec = resources.getSpec(`background`);
        factory.applySpec(this, spec);

        this.baseContainer = factory.createContainer({}, this);
        this.vsContainer = factory.createContainer({visible: false}, this);

        for (const child of Object.values(spec.base)) {
            factory.createSprite(child as SpriteAssetSpec, this.baseContainer);
        }

        for (const child of Object.values(spec.vs)) {
            factory.createSprite(child as SpriteAssetSpec, this.vsContainer);
        }

        this.resize();
        layout.onResize.add(() => this.resize());
    }

    setBase(): void {
        this.baseContainer.visible = true;
        this.vsContainer.visible = false;
    }

    setVS(): void {
        this.baseContainer.visible = false;
        this.vsContainer.visible = true;
    }

    private resize(): void {

        const bounds = this.services.layout.getScreenBoundaryInBucketSpace();

        if (bounds.width > bounds.height) {
            this.width = bounds.width;
            this.scale.y = this.scale.x;

        } else {
            this.height = bounds.height;
            this.scale.x = this.scale.y;
        }
    }
}